// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"515":"5f44e890","766":"ffe7f8e8"}[chunkId] + ".chunk.js";
};